import '@angular/compiler';
import { ComponentProductBarchartComponent } from './component.product.barchart/component.product.barchart.component';
import { PageCommunityComponent } from './page.community/page.community.component';
import { PortalMachineBreakdownComponent } from './portal.machine.breakdown/portal.machine.breakdown.component';
import { PortalAfterserviceWidgetAsWaitingComponent } from './portal.afterservice.widget.as.waiting/portal.afterservice.widget.as.waiting.component';
import { PortalMonitoringAdminStatisticComponent } from './portal.monitoring.admin.statistic/portal.monitoring.admin.statistic.component';
import { PageUserMonitoringComponent } from './page.user.monitoring/page.user.monitoring.component';
import { LayoutUserComponent } from './layout.user/layout.user.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { ComponentChatbotComponent } from './component.chatbot/component.chatbot.component';
import { PortalUserInitializeComponent } from './portal.user.initialize/portal.user.initialize.component';
import { PortalFarmInfoComponent } from './portal.farm.info/portal.farm.info.component';
import { PortalFarmWidgetModalCageInComponent } from './portal.farm.widget.modal.cage.in/portal.farm.widget.modal.cage.in.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalAfterserviceAdminAsListComponent } from './portal.afterservice.admin.as.list/portal.afterservice.admin.as.list.component';
import { PortalMachineMachineComponent } from './portal.machine.machine/portal.machine.machine.component';
import { PageAuthComponent } from './page.auth/page.auth.component';
import { PortalUserListComponent } from './portal.user.list/portal.user.list.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PageUserAsComponent } from './page.user.as/page.user.as.component';
import { ComponentWidgetAllProductComponent } from './component.widget.all.product/component.widget.all.product.component';
import { PortalCommunityViewComponent } from './portal.community.view/portal.community.view.component';
import { ComponentWidgetAllCageComponent } from './component.widget.all.cage/component.widget.all.cage.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalAuthLoginComponent } from './portal.auth.login/portal.auth.login.component';
import { ComponentAdminHomeComponent } from './component.admin.home/component.admin.home.component';
import { PortalFarmWidgetModalCageEnvComponent } from './portal.farm.widget.modal.cage.env/portal.farm.widget.modal.cage.env.component';
import { PortalFarmWidgetModalCageOutComponent } from './portal.farm.widget.modal.cage.out/portal.farm.widget.modal.cage.out.component';
import { PortalCommunityEditComponent } from './portal.community.edit/portal.community.edit.component';
import { PortalAfterserviceUserAsApplyComponent } from './portal.afterservice.user.as.apply/portal.afterservice.user.as.apply.component';
import { ComponentGraphLineComponent } from './component.graph.line/component.graph.line.component';
import { PageUserFarmComponent } from './page.user.farm/page.user.farm.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalAfterserviceWidgetAsStatusComponent } from './portal.afterservice.widget.as.status/portal.afterservice.widget.as.status.component';
import { PortalCommunityNoticeComponent } from './portal.community.notice/portal.community.notice.component';
import { ComponentUserHomeComponent } from './component.user.home/component.user.home.component';
import { PageAdminMonitoringComponent } from './page.admin.monitoring/page.admin.monitoring.component';
import { PageAdminUserComponent } from './page.admin.user/page.admin.user.component';
import { PortalMonitoringAdminMachineComponent } from './portal.monitoring.admin.machine/portal.monitoring.admin.machine.component';
import { ComponentMachineRenderComponent } from './component.machine.render/component.machine.render.component';
import { PortalAfterserviceWidgetAsIngComponent } from './portal.afterservice.widget.as.ing/portal.afterservice.widget.as.ing.component';
import { PortalMonitoringCommonEggpriceComponent } from './portal.monitoring.common.eggprice/portal.monitoring.common.eggprice.component';
import { PortalFarmCheckComponent } from './portal.farm.check/portal.farm.check.component';
import { PortalFarmCageComponent } from './portal.farm.cage/portal.farm.cage.component';
import { PortalMachineCommunicationComponent } from './portal.machine.communication/portal.machine.communication.component';
import { PortalMonitoringUserStatisticComponent } from './portal.monitoring.user.statistic/portal.monitoring.user.statistic.component';
import { PortalAfterserviceIngComponent } from './portal.afterservice.ing/portal.afterservice.ing.component';
import { PortalFarmListComponent } from './portal.farm.list/portal.farm.list.component';
import { PageAdminFarmComponent } from './page.admin.farm/page.admin.farm.component';
import { PortalMonitoringAdminKfarmComponent } from './portal.monitoring.admin.kfarm/portal.monitoring.admin.kfarm.component';
import { PortalCommunityListComponent } from './portal.community.list/portal.community.list.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PortalFarmWidgetAdminFarmTabComponent } from './portal.farm.widget.admin.farm.tab/portal.farm.widget.admin.farm.tab.component';
import { PortalAfterserviceWidgetAsButtonComponent } from './portal.afterservice.widget.as.button/portal.afterservice.widget.as.button.component';
import { LayoutBaseComponent } from './layout.base/layout.base.component';
import { PortalFarmWidgetModalCageSupplyComponent } from './portal.farm.widget.modal.cage.supply/portal.farm.widget.modal.cage.supply.component';
import { ComponentWidgetAllHenComponent } from './component.widget.all.hen/component.widget.all.hen.component';
import { PortalMonitoringAdminApiComponent } from './portal.monitoring.admin.api/portal.monitoring.admin.api.component';
import { PortalAuthJoinComponent } from './portal.auth.join/portal.auth.join.component';
import { PortalAfterserviceStatisticsComponent } from './portal.afterservice.statistics/portal.afterservice.statistics.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalAfterserviceUserAsViewComponent } from './portal.afterservice.user.as.view/portal.afterservice.user.as.view.component';
import { PageAdminAsComponent } from './page.admin.as/page.admin.as.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { ComponentPagenationComponent } from './component.pagenation/component.pagenation.component';
import { PortalAfterserviceUserAsListComponent } from './portal.afterservice.user.as.list/portal.afterservice.user.as.list.component';
import { ComponentNavUserComponent } from './component.nav.user/component.nav.user.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { ComponentModalMessageComponent } from './component.modal.message/component.modal.message.component';
import { PortalAfterserviceAdminAsViewComponent } from './portal.afterservice.admin.as.view/portal.afterservice.admin.as.view.component';
import { PageNotfoundComponent } from './page.notfound/page.notfound.component';
import { PortalFarmAllFarmComponent } from './portal.farm.all.farm/portal.farm.all.farm.component';
import { PortalAfterserviceWidgetAsReportComponent } from './portal.afterservice.widget.as.report/portal.afterservice.widget.as.report.component';
import { ComponentModalAdminUserComponent } from './component.modal.admin.user/component.modal.admin.user.component';
import { PortalUserAllUserComponent } from './portal.user.all.user/portal.user.all.user.component';
import { PortalFarmMachineComponent } from './portal.farm.machine/portal.farm.machine.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { ComponentNavAdminComponent } from './component.nav.admin/component.nav.admin.component';
import { PageMypageUserinfoComponent } from './page.mypage.userinfo/page.mypage.userinfo.component';
import { PortalAfterserviceReplacingMachinepartComponent } from './portal.afterservice.replacing.machinepart/portal.afterservice.replacing.machinepart.component';
import { PortalAfterserviceWaitingComponent } from './portal.afterservice.waiting/portal.afterservice.waiting.component';
import { PortalFarmDashboardComponent } from './portal.farm.dashboard/portal.farm.dashboard.component';
import { ComponentWidgetAllWeightComponent } from './component.widget.all.weight/component.widget.all.weight.component';

const INDEX_PAGE = "home";
const NOT_FOUND_PAGE = "404";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutBaseComponent,
        "children": [
            {
                "path": "community/:category/:action/:post_id?/:parent_id?",
                component: PageCommunityComponent,
                "app_id": "page.community"
            },
            {
                "path": "auth/:type",
                component: PageAuthComponent,
                "app_id": "page.auth"
            },
            {
                "path": "home",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "404",
                component: PageNotfoundComponent,
                "app_id": "page.notfound"
            },
            {
                "path": "mypage/userinfo",
                component: PageMypageUserinfoComponent,
                "app_id": "page.mypage.userinfo"
            }
        ]
    },
    {
        component: LayoutUserComponent,
        "children": [
            {
                "path": "user/monitoring/:type",
                component: PageUserMonitoringComponent,
                "app_id": "page.user.monitoring"
            },
            {
                "path": "user/as/:type/:id?",
                component: PageUserAsComponent,
                "app_id": "page.user.as"
            },
            {
                "path": "user/farm/:type/:farm_id",
                component: PageUserFarmComponent,
                "app_id": "page.user.farm"
            }
        ]
    },
    {
        component: LayoutAdminComponent,
        "children": [
            {
                "path": "admin/monitoring/:type",
                component: PageAdminMonitoringComponent,
                "app_id": "page.admin.monitoring"
            },
            {
                "path": "admin/user/:type",
                component: PageAdminUserComponent,
                "app_id": "page.admin.user"
            },
            {
                "path": "admin/farm/:type/:farm_id?",
                component: PageAdminFarmComponent,
                "app_id": "page.admin.farm"
            },
            {
                "path": "admin/as/:type/:id?",
                component: PageAdminAsComponent,
                "app_id": "page.admin.as"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        // Root path "/" → redirect to home
        if (url.length === 0) {
            return { consumed: url, posParams: {} };
        }
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return null;
    },
    redirectTo: INDEX_PAGE
}, {
    matcher: (url: any) => {
        // Catch-all for unmatched URLs → 404
        if (url.length === 0) return null;
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: NOT_FOUND_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }